import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import ActionsDropdownMenu from '../common/ActionsDropdownMenu';
import { Button } from 'foundations-components/transitional/components/Button';
import UsageTracker from '../../../../utils/UsageTracker';
import { useSyncTableStateWithUrl } from '../../store/myTeamTableStateStoreUtils';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MyTeamFiltersWrapper = ({
  searchInput,
  children,
  isAnyFilterSet,
  onClearAllFilters,
  tableStore,
  showActionsMenu = true,
  showFilterByLabel = true
}) => {
  const isUserPinnableTable = tableStore.state.isUserPinned !== undefined;
  useSyncTableStateWithUrl(tableStore);
  const handleClearAllFilters = () => {
    if (isAnyFilterSet) {
      UsageTracker.track('teamInteraction', {
        action: 'clear-all-filters'
      });
    }
    onClearAllFilters();
  };
  const handleUnpinUserChange = isUserPinned => {
    tableStore.actions.setIsUserPinned(isUserPinned);
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexWrap: "wrap",
    gap: "200",
    marginBlockEnd: "500",
    children: [searchInput && /*#__PURE__*/_jsx(Box, {
      marginInlineEnd: "600",
      children: searchInput
    }), showFilterByLabel && /*#__PURE__*/_jsx(Box, {
      alignItems: "center",
      children: /*#__PURE__*/_jsx(Text, {
        paddingBlock: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myTeam.filters.filterLabel"
        })
      })
    }), children, isAnyFilterSet && /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(Button, {
        marginInlineStart: "500",
        onClick: handleClearAllFilters,
        use: "transparent",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myTeam.filters.clearAllFilters"
        })
      })
    }), showActionsMenu && /*#__PURE__*/_jsx(Box, {
      marginInlineStart: "auto",
      children: /*#__PURE__*/_jsx(ActionsDropdownMenu, {
        isUserPinned: tableStore.state.isUserPinned,
        onUnpinUserChange: isUserPinnableTable ? handleUnpinUserChange : undefined
      })
    })]
  });
};
export default MyTeamFiltersWrapper;